// store.ui
//
//   isSplitView
//     True if screen large enough to show in split view


const defaultState = {
  isLoadingConversations: false,
  isLoadingContacts:      false
};


export default function reducer(ui = defaultState, action) {
  switch (action.type) {

    case 'PROGRESS_START': {
      const inProgress = (ui.inProgress || 0) + 1;
      return { ...ui, inProgress };
    }

    case 'PROGRESS_END': {
      const inProgress = Math.max(ui.inProgress - 1, 0);
      return { ...ui, inProgress };
    }

    case 'UI_TOAST': {
      const toast = action.payload;
      return { ...ui, toast };
    }

    case 'SET_NOTIFICATION': {
      const notification = action.payload;
      return { ...ui, notification };
    }

    case 'SET_IS_LOADING_CONVERSATIONS': {
      const isLoadingConversations = action.payload;
      return { ...ui, isLoadingConversations };
    }

    case 'SET_IS_LOADING_CONTACTS': {
      const isLoadingContacts = action.payload;
      return { ...ui, isLoadingContacts };
    }

    default: {
      return ui;
    }
  }
}

